import React from 'react';

const Text = (props) => {
    return (
        <p className={'text'} style={!!props && !!props.style ? props.style : {}}>{props.children}</p>
    );
}

export default Text;
